import React from "react";
import * as Sentry from "@sentry/react-native";
import useInteractiveLearningData from "../../../hooks/customCoursework/useInteractiveLearningData";
import InteractiveLearningFormCore from "../../../components/customCoursework/ActivityForms/InteractiveLearningForm/InteractiveLearningFormCore";
import type { ActivityDataInput } from "../../../components/customCoursework/ActivityForms/InteractiveLearningForm/InteractiveLearningFormCore";

type InteractiveLearningFormDataContainerProps = {
  activityData?: ActivityDataInput;
  onSave: (data: ActivityDataInput) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  currentDomain?: string;
  imageGenerationSupportFlag?: boolean;
};

const InteractiveLearningFormDataContainer = ({
  activityData,
  onSave,
  onCancel,
  isSubmitting,
  currentDomain,
  imageGenerationSupportFlag = false,
}: InteractiveLearningFormDataContainerProps) => {
  const visualizationId = activityData?.visualizationId ?? null;

  const dataActions = useInteractiveLearningData({
    visualizationId,
    currentDomain,
    onUploadError: (message) => {
      Sentry.captureMessage(message || "Interactive learning image upload failed");
    },
  });

  return (
    <InteractiveLearningFormCore
      activityData={activityData}
      onSave={onSave}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
      imageGenerationSupportFlag={imageGenerationSupportFlag}
      {...dataActions}
    />
  );
};

export default InteractiveLearningFormDataContainer;
